import { Injectable } from '@angular/core';
import { SGF_API } from 'app/shared/api/sgf.api';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContaService {

  private conta = `${SGF_API}`+"sgf/api/public/conta"

  constructor(private httpClient : HttpClient) { }

  findAll(): Observable<any> {
    return this.httpClient.get<any[]>(this.conta)
      .pipe(
        catchError(this.handleError)
      )
  }

  add(conta: any): Observable<any> {
    const body = JSON.stringify(conta);
    return this.httpClient.post(this.conta, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  update(conta: any): Observable<any> {
    const body = JSON.stringify(conta);
    return this.httpClient.put(this.conta, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }


  httpOptions(token?: string): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': ''
      })
    }
  }

  httpOptionsPdf(token?: string): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/pdf',
        'Authorization': ''
      })
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  };
}
